import request from "@/utils/request";

const register = {

	post: (data) => {
		return request({
			url: '/users/register',
			method: 'POST',
			data
		})
	},

}
export default register;